var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "field-permission-set-dialog",
      attrs: {
        visible: _vm.innerVisible,
        title:
          "【" +
          _vm.pageName +
          "】" +
          _vm.$t("SystemMaintenance.FieldPermissionSettings"),
        width: "1200px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "section",
          staticStyle: {
            height: "100%",
            padding: "0 5px",
            display: "flex",
            "flex-direction": "row"
          }
        },
        [
          _c("cargo-ag-grid", {
            staticClass: "left-grid",
            staticStyle: { flex: "0 0 auto", width: "200px", margin: "5px 0" },
            attrs: {
              "grid-options": _vm.left.gridOptions,
              "row-data": _vm.left.rowData,
              "show-side-bar": false
            }
          }),
          _c("div", {
            staticStyle: {
              flex: "0 0 auto",
              width: "2px",
              margin: "0 5px",
              background: "#DCDFE6"
            }
          }),
          _c(
            "div",
            {
              staticClass: "main-content",
              staticStyle: {
                "flex-grow": "1",
                margin: "5px 0",
                display: "flex",
                "flex-direction": "column"
              }
            },
            [
              _c("div", { staticClass: "operations" }, [
                _c("div", { staticClass: "triggers" }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "padding-left": "5px",
                        "margin-bottom": "5px"
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "300px" },
                        attrs: {
                          placeholder: _vm.$t(
                            "SystemMaintenance.FieldNameQuery"
                          )
                        },
                        model: {
                          value: _vm.keyword,
                          callback: function($$v) {
                            _vm.keyword = $$v
                          },
                          expression: "keyword"
                        }
                      }),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSearch }
                        },
                        [_vm._v(_vm._s(_vm.$t("queryJob.Search")))]
                      ),
                      _c("span", { staticStyle: { margin: "0 5px 0 10px" } }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_GeneralSettings")))
                      ]),
                      _c("el-checkbox", {
                        staticStyle: { "margin-right": "10px" },
                        on: { change: _vm.onUseHqSet },
                        model: {
                          value: _vm.permissionManage.useHqSet,
                          callback: function($$v) {
                            _vm.$set(_vm.permissionManage, "useHqSet", $$v)
                          },
                          expression: "permissionManage.useHqSet"
                        }
                      }),
                      _c(
                        "el-button",
                        {
                          key: "save",
                          attrs: { type: "success" },
                          on: { click: _vm.onSave }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                      ),
                      _c(
                        "el-button",
                        {
                          key: "cancel",
                          attrs: { type: "success" },
                          on: { click: _vm.onCancel }
                        },
                        [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
                      )
                    ],
                    1
                  )
                ])
              ]),
              _c("cargo-ag-grid", {
                attrs: {
                  "grid-options": _vm.right.gridOptions,
                  "column-defs": _vm.rightColumnDefs,
                  "row-data": _vm.rightRowData,
                  "show-side-bar": false
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }